import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { UserMe } from "@/lib/types";

/**
 * The signed-in user, as Flow knows them.
 *
 * 🔴 Needed because the OIDC token gives us the Keycloak `sub`, NOT the internal
 * `users.id` — and every person reference in Flow (a person cell, a memo assignee) is the
 * internal id. So "is this task mine?" cannot be answered from the token alone; it needs
 * this. Cached like any other query, so asking repeatedly costs nothing.
 */
export function useMe() {
  return useQuery<UserMe>({ queryKey: queryKeys.me, queryFn: api.me });
}
